"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable:forbid-import */
var satcheljs_1 = require("satcheljs");
/* tslint:enable:forbid-import */
var owa_options_store_1 = require("owa-options-store");
var owa_options_core_1 = require("owa-options-core");
var owa_options_orchestration_1 = require("owa-options-orchestration");
var executeCallbackAndHide = satcheljs_1.orchestratorAction('executeCallbackAndHide', function executeCallbackAndHide(saveDiscardCallback, continueAfterConfirmCallback) {
    if (saveDiscardCallback) {
        saveDiscardCallback();
    }
    continueAfterConfirmCallback();
});
exports.default = satcheljs_1.orchestratorAction('confirmDirtyOptionsAndPerformAction', function hideFullOptions(continueAfterConfirmCallback) {
    var currentSubcategory = owa_options_store_1.getCurrentSubcategory();
    if (owa_options_core_1.isAnyOptionDirty(currentSubcategory)) {
        owa_options_core_1.confirmOptionNavigation({
            onSave: function () {
                executeCallbackAndHide(owa_options_orchestration_1.saveOptions, continueAfterConfirmCallback);
            },
            onDiscard: function () {
                executeCallbackAndHide(owa_options_orchestration_1.discardOptions, continueAfterConfirmCallback);
            },
            shouldDisableSaveButton: owa_options_core_1.shouldDisableSaveButton(currentSubcategory),
        });
    }
    else {
        continueAfterConfirmCallback();
    }
});
//# sourceMappingURL=confirmDirtyOptionsAndPerformAction.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/orchestration/owa-options-orchestration/lib/orchestrators/confirmDirtyOptionsAndPerformAction.js
// module id = 3186
// module chunks = 2